export default "__VITE_ASSET__C1JkLB0z__"